import React from 'react';
import { Container, Alert, Button } from 'react-bootstrap';

type CartErrorProps = {
  error: string;
  messages?: string[] | null;
  onRetry: () => void;
};

const CartError: React.FC<CartErrorProps> = ({ error, messages, onRetry }) => {
  return (
    <div className="cart-page">
      <Container className="py-5">
        <Alert variant="danger">
          <Alert.Heading>Error</Alert.Heading>
          <p className="mb-0">{error}</p>
          {messages && messages.length > 0 && (
            <ul className="mt-2 mb-0 ps-3">
              {messages.map((msg, i) => (
                <li key={i}>{msg}</li>
              ))}
            </ul>
          )}
          <Button variant="outline-danger" className="mt-3" onClick={onRetry}>
            Try Again
          </Button>
        </Alert>
      </Container>
    </div>
  );
};

export default CartError;
